export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/ImageWorker.worker.caa7952925e3aa3e1ed9.worker.js");
}
